// extracted by mini-css-extract-plugin
export default {"container":"style__container___NFuiO","inputContainer":"style__inputContainer___DVSDu","birthDateInput":"style__birthDateInput___aUaBd","label":"style__label___Gd04Z"};